import React, { useEffect } from "react";
import { CircularProgress, Grid } from "@mui/material";
import SortContext from "context/SortContext";
import { useFilter } from "context/FilterContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import GoToTop from "components/ui/GoToTop";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGlobalContext } from "context/GlobalContext";

import SubStockSetProduct from "./SubStockSetProduct";
import { useSubStockSetDesings } from "../api/getSubStockSetDesign";

const SubStockSetsProducts = () => {
  const { nsid } = useParams();
  const { selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const { filterValues } = useFilter();
  const navigate = useNavigate();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, dynamicfilterCount, filterChangeCount, setDynamicFilterCount, setSearchResultCount } = useGlobalContext();

  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const location = useLocation();

  // Location Filter
  // const Location = filterValues?.Location;

  const Location = filterValues?.Location?.map((location) => (location === "IDL" ? "Idel Inventory" : location)) || [];

  // Gold Color Filter
  const goldColorMapping = {
    "Yellow Gold": "Yellow",
    "Rose Gold": "Pink",
    "White Gold": "White",
  };

  const goldColor = filterValues?.["Gold Color"]?.map((color) => goldColorMapping[color]) || [];

  // Gold Purity
  const goldPurity = filterValues?.["Gold Purity"];

  // Diamond Quality
  const diamondQualityMapping = {
    "VVS-EF": "VVSEF",
    "VVS-FG": "VVSFG",
    "VVS-GH": "VVSGH",
    "VSSI-GH": "VSSIGH",
    "VS-GH": "VSGH",
    "SI-IJ": "SIIJ",
    "SI-HI": "SIHI",
  };

  const diamondQuality = filterValues?.["Diamond Quality"]?.map((qlty) => diamondQualityMapping[qlty]) || [];

  // Design Class

  const designClass = filterValues?.Class;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useSubStockSetDesings({
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    searchTerm: search,
    styleNumber: nsid,
    location: Location,
    goldColor,
    goldQlty: goldPurity,
    diaQlty: diamondQuality,
    designClass,
    stockStatus: filterValues["Stock Status"]?.[0] === "On Memo" ? "Memo" : filterValues["Stock Status"]?.[0] || "",
  });

  // useEffect(() => {
  //   setFilterChangeCount(data?.totalSerachAndFilter);
  //   setFilterChangeDesignCount(data?.totalCount);
  //   setDisplayCount(true);
  //   return () => {
  //     setFilterChangeCount(0);
  //     setFilterChangeDesignCount(0);
  //     setDisplayCount(false);
  //   };
  // }, [data]);

  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.totalSerachAndFilter);
      // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
      setSearchResultCount(data?.totalSerachAndFilter);
    } else {
      setSearchResultCount(data?.totalSerachAndFilter);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  // useEffect(()=>{
  //   if(!location?.state){
  //     navigate(location.pathname, { state: { aiIcon: true }, replace: true });
  //   }
  // },[])

  if (isLoading) return <ProductSkeleton count={10} />;
  if (isError) return <div>Error: {error?.message}</div>;

  return (
    <>
      <InfiniteScroll
        dataLength={data?.subStockSetDesigns.length || 0}
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={isFetchingNextPage && <CircularProgress sx={{ display: "flex", justifyContent: "center", margin: "20px auto" }} />}
        scrollThreshold={0.8}
        endMessage={<p style={{ textAlign: "center" }}>You have seen it all!</p>}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
          className="Grid-padding"
        >
          {data?.subStockSetDesigns.map((design) => {
            console.log("design ==>", design);
            const transformedProduct = design;
            return <SubStockSetProduct product={transformedProduct} key={design._id} allData={data?.subStockSetDesigns} />;
          })}
        </Grid>
      </InfiniteScroll>

      <GoToTop />

      {!data?.subStockSetDesigns?.length > 0 && (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            margin: "auto",
            padding: "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "78vh",
          }}
        >
          <Background />
        </div>
      )}
    </>
  );
};

export default SubStockSetsProducts;
